import React, { useEffect, useState } from 'react';
import theme from '../../common/color/theme';
import { CenterLayout, HorizontalLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { Body2, Date2, H3, H8, H9, Name2, Point2, Point3, TitleNormal, TitleNormalBold } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import BTImageInput from '../../common/components/BTImageInput';
import { BTOutlineButton } from '../../common/components/BTOutlineButton';
import '../../css/bbpage.css';
// import { noticePosts, NoticePost, detailText } from '../../common/data/NoticeData';
import { useTranslation } from 'react-i18next';
import AttachDownload from '../../assets/attach_download.svg';
import BtArrowDown from '../../assets/bt_arrow_down.svg';
import BtArrowUp from '../../assets/bt_arrow_up.svg';
import LeftArrowMobile from '../../assets/left_arrow_mobile.svg';
import RightArrowMobile from '../../assets/right_arrow_mobile.svg';
import BTButton from '../../common/components/BTButton';
import { NoticePost } from '../../common/data/NoticeData';
import { fetchNotices } from '../../common/firebase/FirestoreService';
import { pxToRem } from '../../common/utils/ConvertUtils';
import { useDeviceType } from '../../hooks/useDeviceType';
import 'react-quill/dist/quill.snow.css';

type NoticeSection1rops = {
  section1Height: number;
};

const NoticeSection1 = ({ section1Height }: NoticeSection1rops) => {
  const { t } = useTranslation();
  const { horizontal: padding } = useResponsivePadding();
  const [searchText, setSearchText] = useState('');
  const [filteredPosts, setFilteredPosts] = useState<NoticePost[]>([]);
  const [visibleCount, setVisibleCount] = useState(10);
  const [selectedPost, setSelectedPost] = useState<NoticePost | null>(null);
  const [scrollPosY, setScrollPosY] = useState(0);
  const { isMobile } = useDeviceType();
  const [noticePosts, setNoticePosts] = useState<NoticePost[]>([]);

  // 뒤로가기 처리
  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      if (selectedPost) {
        // 히스토리 back 막고 custom 동작 실행
        event.preventDefault(); // 일부 브라우저에서 무시될 수 있음
        setSelectedPost(null);
        window.scrollTo({ top: scrollPosY, behavior: 'instant' });

        // 히스토리 "앞으로 가기" 방지
        window.history.pushState(null, '', window.location.href);
      }
    };

    window.addEventListener('popstate', handlePopState);

    // clean up
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [selectedPost, scrollPosY]);

  useEffect(() => {
    const fetchData = async () => {
      const notices = await fetchNotices();
      const allData: NoticePost[] = notices.map((item, index) => ({
        index: index,
        title: item.title,
        contents: item.contents,
        date: item.postDate
          ? item.postDate.toISOString().slice(0, 10)
          : '',
        attachedFiles: item.attachedFiles,
        isAnchored: item.isAnchored,
      }))
        .sort((a, b) => Number(b.isAnchored) - Number(a.isAnchored));

      setNoticePosts(allData);
      setFilteredPosts(allData);
    };

    fetchData();
  }, []);

  const handleSearch = () => {
    const filtered = noticePosts.filter((post: NoticePost) => {
      const searchableString = [
        post.title,
        post.date,
      ].join(' ').toLowerCase();

      return searchableString.includes(searchText.trim().toLowerCase());
    })
      .sort((a, b) => Number(b.isAnchored) - Number(a.isAnchored));

    setFilteredPosts(filtered);
    setVisibleCount(10);
  };

  const handleShowMore = () => {
    setVisibleCount(prev => prev + 10);
  };

  const visiblePosts = filteredPosts.slice(0, visibleCount);
  const hasMore = visibleCount < filteredPosts.length;

  const handleSave = () => {
    setSelectedPost(null);
  };

  const handleToList = () => {
    setSelectedPost(null);
    setTimeout(() => {
      window.scrollTo({ top: scrollPosY, behavior: 'instant' });
    }, 50);
  };

  const detailContent = () => {
    return (
      <div className="detail-page" style={{ color: 'black' }} dangerouslySetInnerHTML={{ __html: selectedPost?.contents ? `
          <div class="ql-snow">
            <div class="ql-editor">
              ${selectedPost?.contents}
            </div>
          </div>
        ` : "" }} />
    );
  };


  return (
    <VerticalLayout paddingLeft={padding} paddingRight={padding} style={{ background: 'white' }}>
      <BTBox height={isMobile ? 40 : `${pxToRem(100)}`} />
      <H3>Notice</H3>
      <BTBox height={isMobile ? 21 : `${pxToRem(60)}`} />
      {!selectedPost && (
        <>
          {isMobile ? (
            <>
              <HorizontalLayout style={{ alignItems: 'center' }}>
                <VerticalLayout style={{ flex: 1 }} />
                <div style={{
                  width: "100%",
                  height: "40px",
                  border: "1px solid #ccc",     // ✅ 테두리 추가
                  borderRadius: "6px",          // ✅ 둥근 모서리 적용
                  overflow: "hidden",           // ✅ 내부 인풋과 테두리 깔끔하게 맞추기
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "white",     // ✅ 드롭다운 느낌
                  boxSizing: "border-box",
                }}>
                  <BTImageInput
                    hint='Search'
                    value={searchText}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchText(e.target.value)}
                    onKeyDown={(e: React.KeyboardEvent) => {
                      if (e.key === 'Enter') handleSearch();
                    }}
                  />
                </div>
              </HorizontalLayout>
            </>
          ) : (
            <>
              <HorizontalLayout>
                <div style={{ width: isMobile ? '100%' : '480px' }}>
                  <BTImageInput
                    hint='Search'
                    value={searchText}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchText(e.target.value)}
                    onKeyDown={(e: React.KeyboardEvent) => {
                      if (e.key === 'Enter') handleSearch();
                    }}
                  />
                </div>
              </HorizontalLayout>
            </>
          )}

          <BTBox height={isMobile ? 22 : `${pxToRem(10)}`} />
          <VerticalLayout height={isMobile ? 1 : 2} backgroundColor='black' />
          {visiblePosts.map((post: NoticePost, index: number) => (
            <React.Fragment key={index}>
              <HorizontalLayout height={isMobile ? 'auto' : pxToRem(128)}
                style={{
                  alignItems: isMobile ? 'start' : 'center',
                  cursor: 'pointer',
                  flexDirection: isMobile ? 'column' : 'row',
                  justifyContent: isMobile ? 'flex-start' : 'space-between',
                  paddingTop: isMobile ? '18px' : undefined,
                  paddingBottom: isMobile ? '18px' : undefined,
                  backgroundColor: post.isAnchored ? '#f2f2f2' : 'white',
                }}
                onClick={() => {
                  setSelectedPost(post);
                  setScrollPosY(window.scrollY);
                  window.history.pushState(null, '', window.location.href);
                  window.scrollTo({ top: section1Height, behavior: 'instant' });
                }}
                data-analytics-name={`공지사항_${post.title}`}
              >
                {isMobile ? (
                  <HorizontalLayout style={{ alignContent: 'center', alignItems: 'center' }}>
                    <Name2 style={{ width: '38px', textAlign: 'start', fontWeight: `${post.isAnchored ? 700 : 400}` }}>
                      {(post.index + 1)}
                    </Name2 >
                    <VerticalLayout wrapContents={true} style={{ flex: 1 }}>
                      <Body2
                        style={{
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          WebkitLineClamp: 2,
                          maxHeight: '96px',
                          fontWeight: `${post.isAnchored ? 700 : 400}`,
                        }}
                      >
                        {post.title}
                      </Body2>
                      <BTBox height={8} />
                      <Point3 style={{ color: '#464646' }}>{post.date}</Point3>
                    </VerticalLayout>

                  </HorizontalLayout>
                ) : (
                  <>
                    <TitleNormal style={{ fontSize: pxToRem(26), width: pxToRem(100), textAlign: 'center', fontWeight: `${post.isAnchored ? 700 : 400}` }}>
                      {(post.index + 1)}
                    </TitleNormal >
                    <VerticalLayout wrapContents={true} style={{ flex: 1 }}>
                      <Body2
                        style={{
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          WebkitLineClamp: 2,
                          maxHeight: pxToRem(80),
                          fontWeight: `${post.isAnchored ? 700 : 400}`,
                        }}
                      >
                        {post.title}
                      </Body2>
                    </VerticalLayout>
                    <BTBox width={pxToRem(47)} />
                    <Date2 style={{ color: '#464646' }}>{post.date}</Date2>
                    <BTBox width={pxToRem(47)} />
                  </>
                )}
              </HorizontalLayout>
              <VerticalLayout height={1} backgroundColor="black" style={{ opacity: '0.2' }} />
            </React.Fragment>
          ))}

          {hasMore && (
            <>
              <BTBox height={isMobile ? 65 : `${pxToRem(90)}`} />
              <CenterLayout>
                <div style={{ width: isMobile ? '100%' : undefined }}>
                  <BTOutlineButton
                    width={isMobile ? '100%' : `${pxToRem(335)}`}
                    height={isMobile ? 60 : pxToRem(102)}
                    color="#464646"
                    borderColor="#979797"
                    centered={true}
                    onClick={handleShowMore}
                    hoverBackgroundColor={theme.colors.BIBI}
                    hoverTextDecoration='none'
                    hoverBorderColor='white'
                    hoverColor='white'
                    borderWidth={1}
                    fontSize={isMobile ? 15 : pxToRem(28)}
                    data-analytics-name="공지사항_더보기"
                  >
                    더보기
                  </BTOutlineButton>
                </div>
              </CenterLayout>
            </>
          )}
        </>
      )}

      {/* 상세 화면 */}
      {selectedPost && (
        <>
          <div style={{ width: '100%', height: '1px', backgroundColor: 'black' }} />
          <HorizontalLayout
            paddingTop={isMobile ? '18px' : `${pxToRem(40)}`}
            paddingBottom={isMobile ? '16px' : `${pxToRem(40)}`}
            style={{ alignItems: 'center' }}
          >
            <VerticalLayout style={{ flex: 1 }}>
              <H8 style={{ fontSize: isMobile ? '18px' : pxToRem(38), lineHeight: isMobile ? '24px' : pxToRem(38) }}>
                {selectedPost.title.split('\n').map((line, i) => (
                  <React.Fragment key={i}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </H8>
              {isMobile && (
                <>
                  <BTBox height={16} />
                  <Point3 style={{ color: '#464646' }}>{selectedPost.date}</Point3>
                  <BTBox height={16} />
                </>
              )}
            </VerticalLayout>

            {!isMobile && (
              <>
                <VerticalLayout width={100} />
                <Date2 style={{ color: '#464646' }}>{selectedPost.date}</Date2>
              </>
            )}
          </HorizontalLayout>
          <VerticalLayout height={1} backgroundColor="black" style={{ opacity: '0.2' }} />
          {
            selectedPost.attachedFiles.length > 0 && (
              <>
                <BTBox height={isMobile ? 16 : pxToRem(31)} />
                <VerticalLayout backgroundColor='#F4F4F4'>
                  <BTBox height={isMobile ? 16 : pxToRem(15)} />
                  {selectedPost.attachedFiles.map((fileUrl, index) => {
                    const decodedUrl = decodeURIComponent(fileUrl);
                    const cleanUrl = decodedUrl.split('?')[0];
                    const fileName = cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
                    const forcedUrl = `${fileUrl}&response-content-disposition=attachment%3B%20filename%3D${encodeURIComponent(fileName)}`;

                    return (
                      <HorizontalLayout
                        key={index}
                        style={{
                          marginBottom: isMobile ? 13 : pxToRem(15),
                          marginTop: isMobile ? 13 : pxToRem(15),
                          color: '#F4F4F4',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <BTBox width={isMobile ? 16 :  pxToRem(54)} />
                        <TitleNormal fontSize={isMobile ? 14 : 24}>
                          {fileName}
                        </TitleNormal>
                        <VerticalLayout style={{ flex: 1 }} />
                        <a
                          href={forcedUrl}
                          download
                        >
                          <img
                            src={AttachDownload}
                            style={{ width: isMobile ? '20px' : '40px', height: isMobile ? '20px' : '40px', cursor: 'pointer' }}
                            alt="Download"
                          />
                        </a>
                        <BTBox width={pxToRem(54)} />
                      </HorizontalLayout>
                    );
                  })}
                  <BTBox height={pxToRem(15)} />
                </VerticalLayout>
                <BTBox height={pxToRem(40)} />
              </>
            )
          }

          {/* 상세 내용 */}
          {detailContent()}

          <BTBox height={pxToRem(50)} />

          {isMobile ? (
            <>
              <div style={{ width: '100%', height: '1px', backgroundColor: 'black', opacity: 0.2 }} />
              <HorizontalLayout style={{width: '100%'}}>
                {/* selectedPost 앞에 포스트 있는지 확인 */}
                {(() => {
                  const prevPost = [...filteredPosts]
                    .filter((post) => post.index < selectedPost.index)
                    .sort((a, b) => b.index - a.index)[0]; // 가장 큰 index 찾기

                  return prevPost ? (
                    <VerticalLayout>
                      <HorizontalLayout style={{ alignItems: 'center', cursor: 'pointer', paddingTop: '20px', paddingBottom: '20px' }} onClick={() => {
                        setSelectedPost(prevPost)
                        window.history.pushState(null, '', window.location.href);
                        window.scrollTo({ top: section1Height, behavior: 'instant' });
                      }} data-analytics-name="공지사항_이전글">
                        <img src={LeftArrowMobile} />
                        <BTBox width={14} />
                        <Point2>{t('이전 글')}</Point2>
                      </HorizontalLayout>
                    </VerticalLayout>
                  ) : null;
                })()}

                {/* selectedPost 뒤에 포스트 있는지 확인 */}
                {(() => {
                  const prevPost = [...filteredPosts]
                    .filter((post) => post.index > selectedPost.index)
                    .sort((a, b) => a.index - b.index)[0];

                  return prevPost ? (
                    <VerticalLayout style={{alignItems: 'end'}}>
                      <HorizontalLayout wrapContents={true} style={{ alignItems: 'center', cursor: 'pointer', paddingTop: '20px', paddingBottom: '20px' }} onClick={() => {
                        setSelectedPost(prevPost)
                        window.history.pushState(null, '', window.location.href);
                        window.scrollTo({ top: section1Height, behavior: 'instant' });
                        window.scrollTo({ top: section1Height, behavior: 'instant' });
                      }} data-analytics-name="공지사항_다음글">
                        <Point2>{t('다음 글')}</Point2>
                        <BTBox width={14} />
                        <img src={RightArrowMobile} />
                      </HorizontalLayout>
                    </VerticalLayout>
                  ) : null;
                })()}
              </HorizontalLayout>
              <div style={{ width: '100%', height: '1px', backgroundColor: 'black', opacity: 0.2 }} />
            </>
          ) : (
            <>
            {(() => {
            const prevPost = [...filteredPosts]
              .filter((post) => post.index < selectedPost.index)
              .sort((a, b) => b.index - a.index)[0]; // 가장 큰 index 찾기

            return prevPost ? (
              <VerticalLayout>
                <VerticalLayout height={1} backgroundColor="black" style={{ opacity: '0.2' }} />
                <BTBox height={pxToRem(40)} />
                <HorizontalLayout style={{ alignItems: 'center', cursor: 'pointer' }} onClick={() => {
                  setSelectedPost(prevPost)
                  window.history.pushState(null, '', window.location.href);
                  window.scrollTo({ top: section1Height, behavior: 'instant' });
                }} data-analytics-name="공지사항_이전글">
                  <img src={BtArrowUp} style={{width: pxToRem(30), height: pxToRem(30)}}/>
                  <BTBox width={13} />
                  <Point2>{t('이전 글')}</Point2>
                  <BTBox width={30} />
                  <TitleNormalBold style={{ fontSize: pxToRem(26), width: pxToRem(46) }}>
                    {(prevPost.index + 1)}
                  </TitleNormalBold>
                  <H9 style={{ marginRight: 'auto' }}>{prevPost.title}</H9>
                  <Date2 style={{ color: '#464646' }}>{prevPost.date}</Date2>
                </HorizontalLayout>
                <BTBox height={pxToRem(40)} />
              </VerticalLayout>
            ) : null;
          })()}

          <VerticalLayout height={1} backgroundColor="black" style={{ opacity: '0.2' }} />

          {/* selectedPost 뒤에 포스트 있는지 확인 */}
          {(() => {
            const prevPost = [...filteredPosts]
              .filter((post) => post.index > selectedPost.index)
              .sort((a, b) => a.index - b.index)[0];

            return prevPost ? (
              <VerticalLayout>
                <BTBox height={pxToRem(40)} />
                <HorizontalLayout style={{ alignItems: 'center', cursor: 'pointer' }} onClick={() => {
                  setSelectedPost(prevPost)
                  window.history.pushState(null, '', window.location.href);
                  window.scrollTo({ top: section1Height, behavior: 'instant' });
                }} data-analytics-name="공지사항_다음글">
                  <img src={BtArrowDown} style={{width: pxToRem(30), height: pxToRem(30)}}/>
                  <BTBox width={13} />
                  <Point2>{t('다음 글')}</Point2>
                  <BTBox width={30} />
                  <TitleNormalBold style={{ fontSize: pxToRem(26), width: pxToRem(46) }}>
                    {(prevPost.index + 1)}
                  </TitleNormalBold>
                  <H9 style={{ marginRight: 'auto' }}>{prevPost.title}</H9>
                  <Date2 style={{ color: '#464646' }}>{prevPost.date}</Date2>
                </HorizontalLayout>
                <BTBox height={pxToRem(40)} />
                <VerticalLayout height={1} backgroundColor="black" style={{ opacity: '0.2' }} />
              </VerticalLayout>
            ) : null;
          })()}
            </>
          )}

          
          

          <BTBox height={isMobile ? 32 : pxToRem(158)} />
          <CenterLayout>
            {isMobile ? (
              <VerticalLayout>
                <BTButton width='100%' height={isMobile ? '60px' : '62px'}
                  color='#E1E1E1'
                  textColor='#707070'
                  borderColor='#C2C2C2'
                  hoverBorderColor='#979797'
                  hoverColor='#F5F5F5'
                  hoverTextColor='#464646'
                  sx={{
                    fontWeight: 700,
                    fontSize: isMobile ? '15px' : '18px',
                  }}
                  onClick={handleToList} data-analytics-name="공지사항_목록보기">목록보기</BTButton>
              </VerticalLayout>
            ) : (
              <HorizontalLayout wrapContents={true}>
                {/* <BTButton width='359px' height='102px' color={theme.colors.BIBI} textColor='white'
                  sx={{
                    fontWeight: 700,
                    fontSize: '28px',
                  }}
                  onClick={handleSave}>저장하기</BTButton>

                <BTBox width={30} /> */}
                <BTButton width={pxToRem(359)} height={pxToRem(102)}
                  color='#E1E1E1'
                  textColor='#707070'
                  borderColor='#C2C2C2'
                  hoverBorderColor='#979797'
                  hoverColor='#F5F5F5'
                  hoverTextColor='#464646'
                  sx={{
                    fontWeight: 700,
                    fontSize: '28px',
                  }}
                  onClick={handleToList} data-analytics-name="공지사항_목록보기">목록보기</BTButton>
              </HorizontalLayout>
            )}
          </CenterLayout>
        </>
      )}
      <BTBox height={isMobile ? 62 : 300} />
    </VerticalLayout>
  );
};

export default NoticeSection1;
